// extracted by mini-css-extract-plugin
export default {"card-request-info__container":"styles_card-request-info__container__kn07j","notes__container":"styles_notes__container__9gVOM"};